import React from "react";
import "./Footer.css";
import logo from "../assets/logo1.svg";
import { FaMapMarkerAlt, FaPhoneVolume, FaEnvelope, FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn, FaTwitter } from "react-icons/fa";
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer-content">

        {/* Left Side */}
        <div className="footer-left">
          <img src={logo}  className="Footer-logo" />
          <p className="footer-about">
            Making Idea to Reality
          </p>
          <ul className="footer-socials">
            <li>
              <a href="https://www.linkedin.com/company/rosettesmartlife/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/rosette_smartlife/" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@rosette_smart_life" target="_blank" rel="noopener noreferrer">
                <FaYoutube />
              </a>


            </li>
            <li>
              <a href="https://www.linkedin.com/company/rosettesmartlife/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>


            </li>
            <li>
              <a href="https://www.linkedin.com/company/rosettesmartlife/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
            </li>
          </ul>

          {/* <div className="footer-apps">
            <img src={require("../assets/appstore.png")} alt="App Store" className="store-icon" />
            <img src={require("../assets/playstore.png")} alt="Play Store" className="store-icon2" />
          </div> */}
        </div>

        {/* Right Side */}
        <div className="footer-links">

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li>About Us</li>
              <li>Contact Us</li>

              <li>Careers</li>

              <li>Cultures</li>
              <li>Blog</li>

            </ul>
          </div>

          <div className="footer-column">
            <h4>Resources</h4>
            <ul>
              <li>Getting started</li>
              <li>Help center</li>
              <li>Server status</li>
              <li>Report a bug</li>
              <li>Chat support</li>
            </ul>
          </div>

          {/* <div className="footer-column">
            <h4>Programs</h4>
            <ul>
              <li>Weight Loss</li>
              <li>Building Muscles</li>
              <li>Home Workout</li>
              <li>Gym Plan</li>
              <li>Our Plans</li>
              <li>Fitness Group</li>
            </ul>
          </div> */}

          <div className="footer-column">
            <h4>Contact Us</h4>
            <ul className="footer-contact-list">
              <li className="footer-contact-item">
                <span className="contact-icon"><FaMapMarkerAlt /></span>
                <span className="contact-text">Manipal, Karnataka</span>
              </li>
              <li className="footer-contact-item">
                <span className="contact-icon"><FaPhoneVolume /></span>
                <span className="contact-text">Office:08202937763<br />+91 9482650718</span>
              </li>
              <li className="footer-contact-item">
                <span className="contact-icon"><FaEnvelope /></span>
                <span className="contact-text">info@rosettesmartlife.com</span>
              </li>


            </ul>
          </div>

        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        © {currentYear} Rosette Technologies
      </div>
    </footer>
  );
};

export default Footer;
